import React, { useState } from 'react';
import { Card, Badge, Button } from './Shared';
import SafeIcon from '../common/SafeIcon';
import { carrierRates } from '../data/mockData';

const CarrierComparison = () => {
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSearched(true);
    }, 1500);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-100">Carrier Comparison</h1>
        <p className="text-slate-400 mt-1">Simulate routing costs and transit times.</p>
      </div>

      <Card>
        <form onSubmit={handleSearch} className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
          <div className="space-y-1">
            <label className="text-xs text-slate-400 font-medium">Origin Port/Airport</label>
            <div className="relative">
              <SafeIcon name="MapPin" className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input type="text" defaultValue="Shanghai (CNSHA)" className="w-full bg-navy-900 border border-navy-600 rounded-lg py-2 pl-9 pr-3 text-sm text-slate-200 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-all" />
            </div>
          </div>
          <div className="space-y-1">
            <label className="text-xs text-slate-400 font-medium">Destination Port/Airport</label>
            <div className="relative">
              <SafeIcon name="MapPin" className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input type="text" defaultValue="Rotterdam (NLRTM)" className="w-full bg-navy-900 border border-navy-600 rounded-lg py-2 pl-9 pr-3 text-sm text-slate-200 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-all" />
            </div>
          </div>
          <div className="space-y-1">
            <label className="text-xs text-slate-400 font-medium">Cargo Params (TEU/Weight)</label>
            <div className="relative">
              <SafeIcon name="Box" className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input type="text" defaultValue="2x 40HC, 32,000kg" className="w-full bg-navy-900 border border-navy-600 rounded-lg py-2 pl-9 pr-3 text-sm text-slate-200 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-all" />
            </div>
          </div>
          <Button variant="primary" className="w-full py-2.5" onClick={handleSearch}>
            {loading ? <SafeIcon name="Loader" className="animate-spin" /> : <SafeIcon name="Search" />}
            Calculate Routes
          </Button>
        </form>
      </Card>

      {loading && (
        <div className="flex flex-col items-center justify-center py-20 space-y-4">
          <div className="relative w-16 h-16">
            <div className="absolute inset-0 border-4 border-navy-700 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-cyan-500 rounded-full border-t-transparent animate-spin"></div>
          </div>
          <p className="text-cyan-400 font-mono text-sm animate-pulse">Querying global schedules & spot rates...</p>
        </div>
      )}

      {searched && !loading && (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          {carrierRates.map((rate, i) => (
            <Card key={rate.id} className={`relative overflow-hidden ${i === 0 ? 'border-cyan-500/50 shadow-[0_0_20px_rgba(100,255,218,0.1)]' : ''}`}>
              {i === 0 && (
                <div className="absolute top-0 right-0 bg-cyan-500 text-navy-900 text-[10px] font-bold px-2 py-1 rounded-bl-lg">
                  RECOMMENDED
                </div>
              )}
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="font-bold text-slate-200">{rate.name}</h3>
                  <p className="text-xs text-slate-400 mt-1 flex items-center gap-1">
                    <SafeIcon name={rate.type === 'Sea' ? 'Anchor' : 'Navigation'} className="text-[10px]" /> 
                    {rate.type} Freight
                  </p>
                </div>
                <Badge type={rate.reliability > 95 ? 'success' : 'warning'}>{rate.reliability}% Rel.</Badge>
              </div>
              
              <div className="space-y-3 mb-6">
                <div className="flex justify-between items-end border-b border-navy-700 pb-2">
                  <span className="text-sm text-slate-500">Est. Transit</span>
                  <span className="text-lg font-mono text-slate-200">{rate.transitDays} Days</span>
                </div>
                <div className="flex justify-between items-end border-b border-navy-700 pb-2">
                  <span className="text-sm text-slate-500">Total Cost</span>
                  <span className="text-xl font-bold font-mono text-orange-400">${rate.cost.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-end">
                  <span className="text-sm text-slate-500 flex items-center gap-1"><SafeIcon name="Cloud" className="text-xs"/> CO2 Est.</span>
                  <span className="text-sm font-mono text-slate-300">{rate.co2}</span>
                </div>
              </div>

              <Button variant={i === 0 ? "primary" : "secondary"} className="w-full">
                Book Rate
              </Button>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default CarrierComparison;